import { render } from "./FavoritesDialog.vue?vue&type=template&id=3ca14c7c&scoped=true"
import script from "./FavoritesDialog.vue?vue&type=script&lang=js"
export * from "./FavoritesDialog.vue?vue&type=script&lang=js"

import "./FavoritesDialog.vue?vue&type=style&index=0&id=3ca14c7c&scoped=true&lang=css"

import exportComponent from "D:\\Microsoft VS Code Project\\startkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca14c7c"]])

export default __exports__